//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import moment from 'moment/moment';
export default {
  name: 'LogList',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      description: '这是日志管理页面',
      // 查询条件
      queryParam: {
        ipInfo: '',
        createTimeRange: [],
        logType: '2',
        keyWord: ''
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      // 表头
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '日志内容',
        align: 'left',
        dataIndex: 'logContent',
        sorter: true
      }, {
        title: '操作人ID',
        dataIndex: 'userid',
        align: 'center',
        sorter: true
      }, {
        title: '操作人名称',
        dataIndex: 'username',
        align: 'center',
        sorter: true
      }, {
        title: 'IP',
        dataIndex: 'ip',
        align: 'center',
        sorter: true
      }, {
        title: '耗时(毫秒)',
        dataIndex: 'costTime',
        align: 'center',
        sorter: true
      }, {
        title: '日志类型',
        dataIndex: 'logType_dictText',

        /*customRender:function (text) {
          if(text==1){
            return "登录日志";
          }else if(text==2){
            return "操作日志";
          }else{
            return text;
          }
        },*/
        align: 'center'
      }, {
        title: '创建时间',
        dataIndex: 'createTime',
        align: 'center',
        colName: 'create_time',
        sorter: true
      }],
      labelCol: {
        xs: {
          span: 1
        },
        sm: {
          span: 2
        }
      },
      wrapperCol: {
        xs: {
          span: 10
        },
        sm: {
          span: 16
        }
      },
      url: {
        list: '/sys/log/list'
      },
      times: []
    };
  },
  created: function created() {
    this.limitSelectDate = {
      min: moment().startOf('day').subtract(1, 'week'),
      max: moment().endOf('day')
    };
    this.queryParam.createTime_begin = this.limitSelectDate.min.format('YYYY-MM-DD HH:mm:ss');
    this.queryParam.createTime_end = this.limitSelectDate.max.format('YYYY-MM-DD HH:mm:ss');
    this.times = [moment(this.queryParam.createTime_begin, 'YYYY-MM-DD HH:mm:ss'), moment(this.queryParam.createTime_end, 'YYYY-MM-DD HH:mm:ss')];
  },
  methods: {
    getQueryParams: function getQueryParams() {
      console.log(this.queryParam.createTimeRange);
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      delete param.createTimeRange; // 时间参数不传递后台

      return filterObj(param);
    },
    // 重置
    searchReset: function searchReset() {
      var that = this;
      var logType = that.queryParam.logType;
      that.queryParam = {}; //清空查询区域参数

      that.queryParam.logType = logType;
      that.loadData(this.ipagination.current);
    },
    // 日志类型
    callback: function callback(key) {
      var that = this;
      that.queryParam.logType = key;
      that.loadData();
    },
    onDateTime: function onDateTime(value, dateArray) {
      // console.log(value,dateArray)
      this.queryParam.createTime_begin = dateArray[0];
      this.queryParam.createTime_end = dateArray[1];
    },
    onDateOk: function onDateOk(value) {
      console.log(value);
    }
  }
};